import { render, staticRenderFns } from "./BoardingsStep.vue?vue&type=template&id=4c0b074b&scoped=true"
import script from "./BoardingsStep.vue?vue&type=script&lang=js"
export * from "./BoardingsStep.vue?vue&type=script&lang=js"
import style0 from "./BoardingsStep.vue?vue&type=style&index=0&id=4c0b074b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0b074b",
  null
  
)

export default component.exports